/* eslint-disable max-len */
import React from 'react';

export default null;

export const ENCARPAY_APPLICATION_ERROR_CODE = {
	ERROR_BY_IDENTITY: '23001',
	UNEQUAL_CLIENT_INFORMATION: '23003',
	IMPOSSIBLE_CERTIFICATION: '23004',
	INVALID_CERTIFICATION_NUMBER: '23005',
	NOT_FOUND_INFORMATION: '21003',
	FAIL_HYUNDAI_CAPITAL_COMMUNICATION: '21007',
	ETC_ERROR: '23099',
	JB_INVALID_USER_INFO: '26001',
	JB_INVALID_CERTIFICATION_NUMBER: '26002',
	JB_ETC_ERROR: '26099',
	JB_COMMUNICATION_ERROR: '24002', // status : 500
};

export const ENCARPAY_REAPPLY_ERROR_CODE = {
	NOT_FOUND_CLIENT: '20008',
	ALREADY_PROCESSED_ENCAR_PAY: '20009',
	NOT_YET_VEHICLE_CREDIT_LIMIT: '20010',
	EXPIRED_FOR_REUSE: '20011',
	INVALID_INFLOW_FOR_REUSE: '20012',
	INVALID_JUDGEMENT_STATUS_FOR_REUSE: '20015',
	ERROR_UNDEFINED: 'ERROR_UNDEFINED',
};

export const ENCARPAY_REAPPLY_ERROR_INFO = [
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.NOT_FOUND_CLIENT,
		message: '고객정보를 찾을 수 없습니다.',
	},
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.ALREADY_PROCESSED_ENCAR_PAY,
		message: '해당 고객은 현대캐피탈에 기존 승인 내역을 취소 후 진행해야 됩니다.',
	},
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.NOT_YET_VEHICLE_CREDIT_LIMIT,
		message: '한도조회 완료되지 않은 신청건입니다.',
	},
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.EXPIRED_FOR_REUSE,
		message: '사용기한 만료 된 신청건입니다.',
	},
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.INVALID_INFLOW_FOR_REUSE,
		message: '유효한 유입경로가 아닌 신청건입니다.',
	},
	{
		errorCode: ENCARPAY_REAPPLY_ERROR_CODE.INVALID_JUDGEMENT_STATUS_FOR_REUSE,
		message: '승인되지 않은 신청건입니다.',
	},
];

export const ENCARPAY_LIMIT_CHECK_INTEREST_COMPARE_INFO = [
	'금리 비교 결과는 한도조회 한 금융사의 금리를 바탕으로 엔카 제휴 금융사별로 적용될 수 있는 예상 금리입니다.',
	'초기 조회한 금융사가 아닌 다른 엔카 제휴 금융사의 금리로 진행하기 위해서는 조회를 희망하는 금융사로 신용 조회를 진행해야 합니다.',
	'엔카 제휴 금융사에서 대출 진행이 불가능할 시, 예상 금리를 받으실 수 없습니다.',
	'개월 수에 따라서 금리가 다르게 적용되는 금융사도 있습니다.',
	'최종심사 후에 이용 가능한 최대 할부기간은 변경될 수 있습니다.',
];

export const ENCARPAY_INFLOW = {
	MOBILE_ENCAR_PAY: 'MOBILE_ENCAR_PAY', // M_엔카페이_고객
	MOBILE_ENCAR_PAY_HOME_SERVICE: 'MOBILE_ENCAR_PAY_HOME_SERVICE', // M_엔카페이_홈서비스
	MOBILE_ENCAR_PAY_HOME_SERVICE_LOAN: 'MOBILE_ENCAR_PAY_HOME_SERVICE_LOAN', // M_엔카페이_홈서비스_대출
	MOBILE_ENCAR_PAY_HOME_SERVICE_SAFETY: 'MOBILE_ENCAR_PAY_HOME_SERVICE_SAFETY', // 현재 사용 X
	MOBILE_ENCAR_PAY_HOME_SERVICE_REAPPLY: 'MOBILE_ENCAR_PAY_HOME_SERVICE_REAPPLY', // 홈서비스 엔카페이 재신청 고객 상태값 FE에서만 사용
	MOBILE_ENCAR_PAY_AFFILIATE_DEALER: 'MOBILE_ENCAR_PAY_AFFILIATE_DEALER', // M_엔카페이_딜러한도조회
	MOBILE_ENCAR_PAY_MEET_GO: 'MOBILE_ENCAR_PAY_MEET_GO', // M_엔카페이_믿고
	MOBILE_ENCAR_PAY_FAST: 'MOBILE_ENCAR_PAY_FAST', // M_엔카페이_고객_Fast
	MOBILE_ENCAR_PAY_NORMAL: 'MOBILE_ENCAR_PAY_NORMAL', // M_엔카페이_고객_일반
	MOBILE_INTEREST_FREE_HOME_SERVICE: 'MOBILE_INTEREST_FREE_HOME_SERVICE', // M_엔카페이_고객_홈서비스_무이자할부
	ENCAR_PAY_HOME_SERVICE: 'ENCAR_PAY_HOME_SERVICE', // M_엔카페이_고객_홈서비스_후불결제
};

export const COUNSEL_REQUEST_TYPE = {
	NO_COUNSEL_REQUEST: 'NO_COUNSEL_REQUEST',
	AUTO_COUNSEL_REQUEST: 'AUTO_COUNSEL_REQUEST',
	COUNSEL_FOR_MOBILE_ENCARPAY: 'COUNSEL_FOR_MOBILE_ENCARPAY',
	COUNSEL_FOR_AFFILIATION_DEALER: 'COUNSEL_FOR_AFFILIATION_DEALER',
	ONE_STOP_LOAN_EXECUTE: 'ONE_STOP_LOAN_EXECUTE',
};

export const ENCARPAY_JUDGEMENT_STATUS = {
	APPROVE: 'APPROVE',
	REJECT: 'REJECT',
	ERROR: 'ERROR',
};

export const VIRTUAL_ACCOUNT_REAPPLY_TYPE = {
	ALL: 'ALL',
	UNISSUED: 'UNISSUED',
};

export const ENCARPAY_LIMIT = {
	COMPLETELY: 'COMPLETELY',
	PARTLY: 'PARTLY',
	IMPOSSIBLE: 'IMPOSSIBLE',
	ERROR: 'ERROR',
};

export const LOAN_ERROR_CODE = {
	NOT_APPLY_TRUCK: '20002',
	NOT_FOUND_CAR: '20006',
	ALREADY_APPLY: '25001',
	NOT_FOUND_AFFILIATE_DEALER: '25004',
	ALREADY_AFFILIATE: '25006',
};

export const ENCARPAY_ERROR_STATUS = {
	ALREADY_TRANSFERRED: 'ALREADY_TRANSFERRED',
};

export const ENCARPAY_METHOD_PAYMENT_TYPE = {
	ONCE: 'ONCE',
	SPLIT: 'SPLIT',
};

export const LOAN_MONTHLY_DATA_DEFAULT = [
	{
		key: 24,
		value: '24',
		name: '24개월',
	},
	{
		key: 36,
		value: '36',
		name: '36개월',
	},
	{
		key: 48,
		value: '48',
		name: '48개월',
	},
	{
		key: 60,
		value: '60',
		name: '60개월',
	},
];

export const LIMIT_CHECK_EXIST_DURATION = 7; // 한도조회 유지 기간

export const JUDGEMENT_KEY = {
	HYUNDAICAPITAL: 'hyundaiCapitalJudgement',
	BNKCAPITAL: 'bnkCapitalJudgement',
	JBCAPITAL: 'jbCapitalJudgement',
};

export const ENCARPAY_LOAN_COMPANY = {
	HYUNDAICAPITAL: 'HYUNDAICAPITAL',
	JBCAPITAL: 'JBCAPITAL',
	BNKCAPITAL: 'BNKCAPITAL',
};

export const LOAN_INFO_MAP = new Map([
	[
		'JBCAPITAL',
		{
			rate: '5.5 ~ 15.0% (고정금리)',
			date: '',
			deliberation1: '여신금융협회 심의필 : 제2026-L1h-01614호(2026.02.10~2027.02.09)',
		},
	],
	[
		'BNKCAPITAL',
		{
			rate: '최저 연 4.9 ~ 최고 연 13.5%(개인신용평점 및 구간별 차등적용)',
			date: '',
			deliberation1: '제2025-0010호(2025.01.06~2026.01.05)',
			deliberation2: (
				<>
					제2025-C1h-00547호 <br /> (2025.01.14~2026.01.13)
				</>
			),
		},
	],
]);

export const LOAN_TERM_DEFAULT_PATH = '/encar-pay/terms/required';
export const MOBILE_CARRIER_TERM_PATH = '/encar-pay/terms/mobile-carrier';

export const HYUNDAI_LABEL = [
	{ label: '개인정보 수집·이용', page: 1 },
	{ label: '고유식별정보 수집·이용', page: 2 },
	{ label: '민감정보 수집 이용', page: 3 },
	{ label: '개인(신용)정보 조회', page: 4 },
	{ label: '고유식별정보 조회', page: 5 },
	{ label: '개인(신용)정보 제공', page: 6 },
	{ label: '고유식별정보 제공', page: 7 },
	{ label: '민감정보 제공', page: 8 },
	{
		label: '금융결제원 필수 동의',
		page: 9,
		children: ['term_10', 'term_11'],
	},
	{
		label: '개인신용정보 이용 관련 동의',
		page: 10,
		parentId: 'term_9',
		sibling: ['term_11'],
	},
	{
		label: '개인신용정보 제3자 제공 관련 동의',
		page: 11,
		parentId: 'term_9',
		sibling: ['term_10'],
	},
];

export const JB_LABEL = [
	{ label: '개인(신용)정보 필수적 수집,이용', page: 1 },
	{ label: '개인(신용)정보 필수적 조회', page: 2 },
	{ label: '개인(신용)정보 필수적 제공', page: 3 },
];

export const 통신사약관타입 = {
	통신사_공통: '통신사_공통', // NICE,KCB 별 차이만 존재
	신용평가사_공통: '신용평가사_공통', // SKT,LG,KT 차이만 존재
	유니크: '유니크',
};

// HYUNDAI / BNK
export const MOBILE_CARRIER_TERM_DEFAULT_CASE = [
	{ label: '개인(신용)정보 수집·이용 동의(필수)', page: 1, type: 통신사약관타입.유니크 },
	{ label: '고유식별정보 수집·이용 동의(필수)', page: 2, type: 통신사약관타입.유니크 },
	{ label: '통신사 이용약관 동의(필수)', page: 3, type: 통신사약관타입.신용평가사_공통 },
	{ label: '서비스 이용약관 동의(필수)', page: 4, type: 통신사약관타입.통신사_공통 },
	{
		label: '개인정보 제3자 제공 동의(필수)',
		page: 5,
		type: 통신사약관타입.신용평가사_공통,
		isMvnoOnly: true,
	},
];

// 이 부분이 적합성 페이지에서 바텀시트로 나와야 한다
export const MOBILE_CARRIER_TERM_BNK_CASE = [...JB_LABEL];

export const MOBILE_CARRIER_TERM_JB_CASE = [
	{ label: '개인정보 수집·이용 및 제공동의(필수) - (본인확인)', page: 1 },
	{ label: '고유식별정보의 수집·이용에 대한 동의(필수)', page: 2 },
	{ label: '통신사별 이용약관(필수)', page: 3 },
];

export const LIMIT_CHECK_RESULT = {
	EXIT: 'EXIT',
	APPLY: 'APPLY',
};
export const VALIDATION_DEFAULT_VALUE = {
	name: { invalidate: false, msg: '' },
	residentNumber: { invalidate: false, msg: '' },
	phone: { invalidate: false, msg: '' },
	certificationNumber: { invalidate: false, msg: '' },
};

export const MOBILE_CARRIER = {
	SKT: 'SKT',
	KT: 'KT',
	'LG U+': 'LGT',
	'SKT 알뜰폰': 'SKT_MVNO',
	'KT 알뜰폰': 'KT_MVNO',
	'LG U+ 알뜰폰': 'LGT_MVNO',
};

export const mobileCarrierOptions = Object.keys(MOBILE_CARRIER).map((key) => ({ key, value: MOBILE_CARRIER[key], name: key }));

export const CREDIT_TAB_TYPE = {
	NICE: 'NICE',
	KCB: 'KCB',
	COMMON: 'COMMON',
};

export const RECENT_LIMIT_CHECK_SUCEESS_TYPE = {
	JB: 404,
};

export const FINANCIAL_COMPANY = {
	HYUNDAICAPITAL: 'HYUNDAICAPITAL',
	JBCAPITAL: 'JBCAPITAL',
	BNKCAPITAL: 'BNKCAPITAL',
};

export const ETC = 'ETC';

export const CREDIT_SCORE_TYPE = {
	DONT_KNOW: 'DONT_KNOW',
	MANUAL_INPUT: 'MANUAL_INPUT',
};

export const SUITABILITY_INTITIAL_STATE = {
	INITIAL_VALUE: {
		financialConsumerType: '',
		loanUsage: '',
		sourceOfFunds: '',
		amountOfAssetsHeld: '',
		annualIncome: '',
		debtAmount: '',
		fixedExpenditure: '',
		reimbursementPlan: '',
	},
	INITIAL_CREDIT_SCORE: {
		type: '',
		value: '',
	},
	INITIAL_ETC: {
		loanUsage: '',
		sourceOfFunds: '',
		reimbursementPlan: '',
	},
	INITIAL_ERROR: {
		financialConsumerType: '',
		loanUsage: '',
		sourceOfFunds: '',
		amountOfAssetsHeld: '',
		annualIncome: '',
		debtAmount: '',
		fixedExpenditure: '',
		creditScore: '',
		reimbursementPlan: '',
	},
	ERROR_MESSAGE_EMPTY: {
		loanUsage: '대출 용도를 입력해 주세요.',
		sourceOfFunds: '자금 출처를 입력해주세요.',
		creditScore: '신용점수를 입력해주세요.',
		reimbursementPlan: '변제 계획을 입력해주세요.',
	},
	ERROR_MESSAGE: {
		financialConsumerType: '전문금융소비자여부를 선택해주세요',
		loanUsage: '대출 용도를 선택해 주세요.',
		sourceOfFunds: '자금 출처를 선택해주세요.',
		amountOfAssetsHeld: '보유자산을 선택해주세요.',
		annualIncome: '연간 소득을 선택해주세요.',
		debtAmount: '부채현황을 선택해주세요.',
		fixedExpenditure: '고정 지출 현황을 선택해주세요.',
		creditScore: '신용점수를 선택해주세요.',
		reimbursementPlan: '변제 계획을 선택해주세요.',
	},
	ERROR_MESSAGE_MAX_VALUE: {
		creditScore: '1~1000까지 입력 가능합니다.',
		reimbursementPlan: '1~31까지 입력 가능합니다.',
	},
};

export const SUITABILITY_MAX_VALUE = {
	creditScore: 1000,
	reimbursementPlan: 31,
};

export const AGREE_ERROR_MESSAGE = {
	INITIAL: null,
	NON_SELECT: '개인정보 수집 및 이용 제공에 동의해 주세요.',
	NOT_AGREE: '미동의시 한도조회 진행이 불가능합니다.',
};

export const AGREE_TYPE = {
	NON_SELECT: null,
	NOT_AGREE: false,
};

export const ENCARPAY_BIRTH_YEAR = 'ENCARPAY_BIRTH_YEAR';
export const ENCARPAY_USER_NAME = 'ENCARPAY_USER_NAME';
export const ENCARPAY_JUDGEMENT_ID = 'ENCARPAY_JUDGEMENT_ID';
export const INVALID_ERROR_MESSAGE = (
	<>
		한도조회 진행 중 오류가 발생되었습니다.
		<br />
		잠시 후 진행해주세요.
	</>
);

export const ENCARPAY_MAXLENGTH = {
	sourceOfFunds: 15,
	loanUsage: 15,
	creditScore: 4,
	reimbursementPlan: 2,
};

export const LIMIT_RESULT_PAGE_TYPE = {
	ONE_STOP_LOAN_EXECUTE_PENDING: 'ONE_STOP_LOAN_EXECUTE_PENDING',
	SUCCESS: 'SUCCESS',
	TRANSFERRED: 'TRANSFERRED',
};

export const ENCARPAY_ROUTES = {
	ONE_STOP_LOAN_EXECUTE_PENDING: '/loan/one-stop-process/pending',
	ONE_STOP_LOAN_EXECUTE_FORM: '/loan/one-stop-process/form',
	ONE_STOP_LOAN_EXECUTE_AFTER_APPLY: '/loan/one-stop-process/after-apply',
};

export const ONE_STOP_ERROR_CODE = new Set(['23101', '23102', '23199']);
